export const STORY_ENGAGEMENT_APP = "StoryEngagement";
export const STORY_THREAD_ENTITY_TYPE = "StoryThread";
export const STORY_COMMENT_ENTITY_TYPE = "StoryComment";

export const KIND_LIKE = "like";
export const KIND_VOTE = "vote";

export const COMMENT_STATUS_ACTIVE = "active";
export const COMMENT_MODERATION_APPROVED = "approved";
export const COMMENT_MODERATION_ESCALATED = "escalated";

export const MODERATION_APPROVE = "approve";
export const MODERATION_BLOCK = "block";
export const MODERATION_ESCALATE = "escalate";

export const EVENT_LIKE_STORY = "LikeStory";
export const EVENT_UNLIKE_STORY = "UnlikeStory";
export const EVENT_UPVOTE_STORY = "UpvoteStory";
export const EVENT_DOWNVOTE_STORY = "DownvoteStory";
export const EVENT_REMOVE_VOTE_FROM_STORY = "RemoveVoteFromStory";
export const EVENT_LIKE_COMMENT = "LikeComment";
export const EVENT_UNLIKE_COMMENT = "UnlikeComment";
export const EVENT_UPVOTE_COMMENT = "UpvoteComment";
export const EVENT_DOWNVOTE_COMMENT = "DownvoteComment";
export const EVENT_REMOVE_VOTE_FROM_COMMENT = "RemoveVoteFromComment";
export const EVENT_POST_COMMENT = "PostComment";
export const EVENT_REPLY_TO_COMMENT = "ReplyToComment";
export const EVENT_EDIT_COMMENT = "EditComment";
export const EVENT_REPORT_COMMENT = "ReportComment";
export const EVENT_DELETE_COMMENT = "DeleteComment";
export const EVENT_MODERATOR_DELETE_COMMENT = "ModeratorDeleteComment";
export const EVENT_APPROVE_COMMENT = "ApproveComment";
export const EVENT_BLOCK_COMMENT = "BlockComment";
export const EVENT_ESCALATE_COMMENT = "EscalateComment";

export const USER_BLOCKING_APP = "UserBlocking";
export const USER_BLOCK_ENTITY_TYPE = "UserBlock";
export const BLOCK_STATUS_ACTIVE = "active";
export const EVENT_BLOCK_USER = "BlockUser";
export const EVENT_UNBLOCK_USER = "UnblockUser";
